<template>
  <div id="crash">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>崩溃列表</el-breadcrumb-item>
    </el-breadcrumb>
      <el-card class="box-card">
        <el-table size="small" :data="tableData" border style="width: 100%">
            
            <el-table-column
                      type="index"
                      label="#">
            </el-table-column>
           
            <el-table-column label="用户ID" width="100">
                  <template slot-scope="scope">
                      {{ scope.row.user_id }}
                  </template>
            </el-table-column>

            <el-table-column  label="崩溃类容">
                <template slot-scope="scope">
                    {{scope.row.crash_info}}
                </template>
            </el-table-column>

             <el-table-column  label="崩溃时间">
                <template slot-scope="scope">
                    {{scope.row.crash_data}}
                </template>
            </el-table-column>

             <el-table-column  label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 0" style="color:red;">未处理</span>
                    <span v-if="scope.row.status == 1" style="color:#00a846;">已解决</span>
                </template>
            </el-table-column>

            <el-table-column
                    width="150"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="warning" plain size="small" @click="edit(scope.row.id)">修改</el-button>
                    <el-button type="danger" plain size="small" @click="remove(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="el-pagination">
            <el-pagination
                    background
                    @size-change="changeSize"
                    @current-change="changeCurrent"
                    :current-page="params.pagenum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="params.pagesize"
                    :total="params.totals"
                    :layout="this.$store.state.paginationLayout">
            </el-pagination>
        </div>

        <el-dialog :title="fromTitle"
                       :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'90%':'50%'"
                       :visible.sync="visible">
                <el-form ref="form"
                         :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'200px'"
                         size="small">
                    
                      <el-form-item label="是否解决">
                          <el-select v-model="form.status" placeholder="请选择"
                                    :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                              <el-option label="是" value="1"></el-option>
                              <el-option label="否" value="0"></el-option>
                          </el-select>
                      </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
    </el-card>
  </div>
</template>  
<script>
import {isRealNum} from '../../utils/common'
export default {
  name: "crash",
  data(){
      return {
        params:{
          pagenum: 1,
          pagesize: 10,
          totals: 0
        },
        form:{
         status: '',
        },
        tableData:[],
        fromTitle: '',
        visible:false,
        id:'',
      };
  },
  created(){
    this.getList();
  },
  methods:{
    // 每页显示多少条
    changeSize(val){
      this.params.page_size = val;
      this.getList();
    },
     // 当前显示的页数
    changeCurrent(val) {
      this.params.page_num = val;
      this.getList();
    },
    getList(){
      let data = {
        page:this.params.page_num,
        page_size:this.params.page_size
      };
      this.$axios.post('admin/crash/index',data).then(res => {
          this.params.totals = parseInt(res.data.count);
          this.tableData = res.data.list;
      });
    },
      // 编辑用户
    edit(id) {
        this.id = id;
        this.fromTitle = '编辑';
        this.$axios.get('admin/crash/' + id, {}).then((res) => {
            let data = res.data;
            for (let key in data) {
                if (isRealNum(data[key])) {
                    data[key] = data[key].toString()
                }
            }
            this.form = data;
            this.visible = true;
        });
    },
     // 确认提交添加或编辑用户
    dialogAffirm() {
        if (this.id) {
            this.$axios.put('admin/crash/' + this.id, this.form).then((res) => {
                this.$message.success('成功');
                this.getList();
                this.visible = false;
            });
        } else {
            // 添加
            this.$axios.post('/admin/crash', this.form).then((res) => {
                this.$message.success('成功');
                this.getList();
                this.visible = false;
            });
        }
    },
    remove(id) {
            this.$confirm('确定要进行操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.del('admin/crash/' + id, '').then((res) => {
                    this.$message.success('删除成功!');
                    this.getList();
                });
            }).catch(() => {

            });
        },
    }
  }
</script>
